import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

type Props = {
  label: string;
  bold?: boolean;
  onClick: () => void;
};

export function ATEventRow({ label, bold, onClick }: Props) {
  return (
    <div className={styles.eventRow}>
      <button onClick={onClick}>
        <Body
          variant={bold ? 'sm-bold' : 'sm-regular'}
          className={styles.eventRowButton}
          as="span"
        >
          {label}
        </Body>
      </button>
    </div>
  );
}
